import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import Screenshot from './components/screenshot/Screenshot';

ReactDOM.render(
  <React.StrictMode>
    <Screenshot />
  </React.StrictMode>,
  document.getElementById('root'),
);
